import { createFileRoute } from '@tanstack/react-router';
import { Permission } from '../../../features/common/permision';
import { VideoTranslationPage } from '../../../features/video/video-translation.page';

export const Route = createFileRoute('/_creator-center/video/translation')({
  staticData: { permissions: [Permission.视频翻译] },
  component: VideoTranslationPage,
});
